export const TABS = {
  QUARTERLY: 'quarterly',
  YTD: 'ytd',
  PRIOR_CALENDAR_YEAR: 'prior-calendar-year',
} as const;
export type SectorAttributionTab = (typeof TABS)[keyof typeof TABS];

export const Constants = {
  TAG_NAME: 'pop-sector-attribution-component',
  COMPONENT_TITLE: 'Sector attribution',
  QUARTERLY_TAB_LABEL: 'Quarterly',
  YTD_TAB_LABEL: 'YTD',
  PRIOR_CALENDAR_YEAR_TAB_LABEL: 'Prior calendar year',
  DATA_AS_OF_DROPDOWN_LABEL: 'Data as of',
  DATA_AS_OF_DROPDOWN_ID: 'data-as-of-select',
  NO_DATA_MESSAGE: 'Sector attribution unavailable',
} as const;
